<ng-container [ngSwitch]="typeOfCarousel">
    <ng-template
        [ngSwitchCase]="carousel.ListsCollection"
        *ngIf="items.lists"
    >
        <div
            *ngIf="items.lists.length > 0"
            class="container-slider ListsCollection"
        >
            <div class="container-title-slider">
                <p [textContent]="title"></p>
            </div>
            <div class="container-main-slider">
                <div class="wrapper-container">
                    <ng-template
                        ngFor
                        [ngForOf]="items.lists"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div class="items slider-small-square-item">
                            <div
                                class="square-pic"
                                (click)="[
                                            goTocatagory('/catalog', { listKey: item.apiUrl,title: item.title }),
                                            analyticsEvent(item.apiUrl, item.title, idx)
                                         ]"
                            >
                                <img
                                    [lazySrc]="BASE_HREF_IMAGE + item.imageUrl + '?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                    lazySrcVisible="visible"
                                    src="assets/img/placeholder.png"
                                    [alt]="item.title"
                                    loading="lazy"
                                    class="square-image"
                                >
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.Simple_H"
        *ngIf="items.items"
    >
        <ng-container *ngTemplateOutlet="Simple_H"></ng-container>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.Simple_V"
        *ngIf="items.items"
    >
        <div
            *ngIf="items?.items.length > 0"
            class="container-slider Simple_V"
        >
            <div class="container-main-slider">
                <div class="simple-v-wrapper-container">
                    <ng-template
                        ngFor
                        [ngForOf]="items.items"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            (click)="[
                                        navigate(item.identifier, item.title, item),
                                        analyticsEvent(item.identifier, item.title, idx)
                                      ]"
                            class="items"
                        >
                            <ng-container *ngTemplateOutlet="rating; context: item.rating"></ng-container>
                            <div class="container-img">
                                <img
                                    src="assets/img/placeholder.png"
                                    [lazySrc]="BASE_HREF_IMAGE + '/content/books/' + item.audioBookId + '/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion "
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    class="wrapper-img-slider"
                                >
                                <ng-container *ngTemplateOutlet="discountBadge; context: { $implicit: item }"></ng-container>
                            </div>
                            <div class="container-desc">
                                <h2 class="truncate">
                                    <span [textContent]="item.title"></span>
                                </h2>
                                <ng-container *ngTemplateOutlet="authors;context: { $implicit: item.authors }"></ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.Simple_small"
        *ngIf="items.items"
    >
        <div
            *ngIf="items?.items.length > 0"
            class="container-slider Simple_small"
        >
            <ng-container *ngTemplateOutlet="btnShowAll"></ng-container>
            <div class="container-main-slider">
                <div class="wrapper-container">
                    <ng-template
                        ngFor
                        [ngForOf]="items.items"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            (click)="[
                                        navigate(item.identifier, item.title),
                                        analyticsEvent(item.identifier, item.title, idx)
                                      ]"
                            class="items slider-small-square-item"
                        >
                            <div class="square-pic">
                                <img
                                    src="assets/img/placeholder.png"
                                    [lazySrc]="BASE_HREF_IMAGE + '/content/books/' + item.audioBookId +'/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    class="square-image"
                                >
                                <ng-container *ngTemplateOutlet=" discountBadge; context: { $implicit: item }"></ng-container>
                            </div>
                            <div class="container-desc">
                                <h2 class="truncate">
                                    <span [textContent]="item.title"></span>
                                </h2>
                                <ng-container *ngTemplateOutlet="authors; context: { $implicit: item.authors }"></ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.Linear"
        *ngIf="items.items"
    >
        <div
            *ngIf="items.items.length > 0"
            class="Linear container-slider box-list-shop"
        >
            <ng-container *ngTemplateOutlet="btnShowAll"></ng-container>
            <section class="container-list">
                <div class="wrapper">
                    <ng-template
                        ngFor
                        [ngForOf]="items.items"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            (click)="[
                                        navigate(item.identifier, item.title),
                                        analyticsEvent(item.identifier, item.title, idx)
                                      ]"
                            class="wrapper-item"
                            *ngIf="idx < 3"
                        >
                            <div class="item-img">
                                <img
                                    src="assets/img/placeholder.png"
                                    [lazySrc]=" BASE_HREF_IMAGE +'/content/books/' + item.audioBookId +'/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                >
                                <ng-container *ngTemplateOutlet="discountBadge;context: { $implicit: item }"></ng-container>
                            </div>
                            <div class="item-text">
                                <ng-container *ngIf="item.narrators">
                                    <div
                                        class="templateWithNarrators"
                                        *ngIf="item.narrators.length > 0"
                                    >
                                        <div class="item-text-header">
                                            <span
                                                class="item-name"
                                                [textContent]="item.title"
                                            ></span>
                                            <div
                                                class="box-rate-one-star"
                                                *ngIf="item.rating.average"
                                            >
                                                <span
                                                    class="box-rate-yellow"
                                                    [textContent]="item.rating.average || '--'"
                                                ></span>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="item.authors">
                                            <div
                                                class="truncate box-authors"
                                                *ngIf="item.authors.length > 0"
                                            >
                                                <span
                                                    [textContent]="item.authors | combineMultipleName"
                                                    class="item-author"
                                                ></span>
                                            </div>
                                        </ng-container>
                                        <div class="truncate box-narrators">
                                            <span
                                                [textContent]="item.narrators | combineMultipleName"
                                                class="item-narrator"
                                            ></span>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!item.narrators">
                                    <div
                                        class="templateWithOutNarrators"
                                        *ngIf="item.narrators.length < 0"
                                    >
                                        <span
                                            class="item-name"
                                            [textContent]="item.title"
                                        ></span>
                                        <ng-container *ngIf="item.authors">
                                            <div
                                                class="truncate box-authors"
                                                *ngIf="item.authors.length > 0"
                                            >
                                                <span
                                                    [textContent]="item.authors | combineMultipleName"
                                                    class="item-author"
                                                ></span>
                                            </div>
                                        </ng-container>
                                        <span
                                            *ngIf="item.rating.average"
                                            class="number-rate"
                                            [textContent]="item.rating.average"
                                        ></span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </section>
        </div>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.Series"
        *ngIf="items.items"
    >
        <div
            *ngIf="items.items.length > 0"
            class="container-slider Series"
        >
            <ng-container *ngTemplateOutlet="btnShowAll"></ng-container>
            <div class="container-main-slider">
                <div class="wrapper-container">
                    <ng-template
                        ngFor
                        [ngForOf]="items.items"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            class="items"
                            (click)="[
                                        navigate(item.identifier, item.title),
                                        analyticsEvent(item.identifier, item.title, idx)
                                      ]"
                        >
                            <ng-container *ngTemplateOutlet="shadow"></ng-container>
                            <div class="container-img">
                                <img
                                    src="assets/img/placeholder.png"
                                    [lazySrc]="BASE_HREF_IMAGE + '/content/books/' + item.audioBookId + '/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    class="wrapper-img-slider"
                                >
                                <ng-container *ngTemplateOutlet="discountBadge; context: { $implicit: item }"></ng-container>
                            </div>
                            <div class="container-desc">
                                <h2 class="truncate">
                                    <span [textContent]="item.title"></span>
                                </h2>
                                <ng-container *ngTemplateOutlet="authors; context: { $implicit: item.authors }"></ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.WithDesc_V"
        *ngIf="items.items"
    >
        <!-- <section class="container-list">
            <div class="wrapper">
                <ng-template
                    ngFor
                    [ngForOf]="items"
                    let-item
                    let-idx=index
                    [ngForTrackBy]="trackByFn()"
                >
                    <div
                        (click)="navigate(item.identifier, item.title)"
                        class="wrapper-medium-new-item"
                    >
                        <div class="medium-item-img">
                            <img
                                [lazySrc]="BASE_HREF_IMAGE + '/content/books/'+ item.audioBookId +'/pic.jpg?t=' + item.recordVersion"
                                lazySrcVisible="visible"
                                loading="lazy"
                                src="assets/img/placeholder.png"
                            >
                        </div>
                        <div class="truncate medium-item-text">
                            <span
                                class="medium-item-title"
                                [textContent]="item.title"
                            ></span>
                            <span class="medium-item-category">??? 3</span>
                            <div class="medium-item-subject">
                                <span>???????? / ???????</span>
                            </div>
                            <span class="medium-item-des">
                                ??? ???? ??? ????? ???? ???? ??? ???? ??? ????? ???? ????
                            </span>
                        </div>
                    </div>
                </ng-template>
            </div>
        </section> -->
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.ArtistCircle"
        *ngIf="items?.artistsItems"
    >
        <div
            *ngIf="items?.artistsItems.length > 0"
            class="box-slider-circel ArtistCircle"
        >
            <div class="container-title-slider">
                <p [textContent]="title"></p>
            </div>
            <div class="container-slider circel-list">
                <div class="track-circel">
                    <ng-template
                        ngFor
                        [ngForOf]="items.artistsItems"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            (click)="[
                                        analyticsEvent(item.artist.identifier, item.artist.firstName + ' ' + item.artist.lastName, idx),
                                        goToArtistPage(item.artist.identifier)
                                      ]"
                            class="slider-small-circel-item"
                        >
                            <div class="circel-pic">
                                <img
                                    [lazySrc]=" BASE_HREF_IMAGE + item.featuredItemImageUrl +'/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                    src="assets/img/placeholder.png"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    class="circel-image"
                                >
                            </div>
                            <div class="title-circle">
                                <h2 class="truncate">
                                    <span [textContent]="item.title"></span>
                                </h2>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>




  <ng-template
          [ngSwitchCase]="carousel.PublisherCircle"
          *ngIf="items?.publisherItems"
  >
    <div
            *ngIf="items?.publisherItems.length > 0"
            class="box-slider-circel ArtistCircle"
    >
      <div class="container-title-slider">
        <p [textContent]="title"></p>
      </div>
      <div class="container-slider circel-list">
        <div class="track-circel">
          <ng-template
                  ngFor
                  [ngForOf]="items.publisherItems"
                  let-item
                  let-idx="index"
                  [ngForTrackBy]="trackByFn"
          >
            <div
                    (click)="[
                                        analyticsEvent(item.publisher.identifier, item.publisher.name, idx),
                                        goToPublisherPage(item.publisher.identifier)
                                      ]"
                    class="slider-small-circel-item"
            >
              <div class="circel-pic">
                <img
                        [lazySrc]=" BASE_HREF_IMAGE + item.featuredItemImageUrl +'/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                        src="assets/img/placeholder.png"
                        lazySrcVisible="visible"
                        loading="lazy"
                        class="circel-image"
                >
              </div>
              <div class="title-circle">
                <h2 class="truncate">
                  <span [textContent]="item.title"></span>
                </h2>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>





    <ng-template
        [ngSwitchCase]="carousel.Series_Small"
        *ngIf="items.items"
    >
        <div
            *ngIf="items.items.length > 0"
            class="container-slider Series_Small"
        >
            <ng-container *ngTemplateOutlet="btnShowAll"></ng-container>
            <div class="container-main-slider">
                <div class="wrapper-container">
                    <ng-template
                        ngFor
                        [ngForOf]="items.items"
                        let-item
                        let-idx="index"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            (click)="[
                                        analyticsEvent(item.identifier, item.title, idx),
                                        navigate(item.identifier, item.title)
                                      ]"
                            class="items slider-small-square-item"
                        >
                            <ng-container *ngTemplateOutlet="shadow"></ng-container>
                            <div class="square-pic">
                                <img
                                    src="assets/img/placeholder.png"
                                    [lazySrc]="BASE_HREF_IMAGE +'/content/books/' + item.audioBookId + '/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                    lazySrcVisible="visible"
                                    loading="lazy"
                                    class="square-image"
                                >
                                <ng-container *ngTemplateOutlet="discountBadge;context: { $implicit: item }"></ng-container>
                            </div>
                            <div class="container-desc">
                                <h2 class="truncate">
                                    <span [textContent]="item.title"></span>
                                </h2>
                                <ng-container *ngTemplateOutlet="authors; context: { $implicit: item.authors }"></ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        [ngSwitchCase]="carousel.image_Only"
        *ngIf="items.items"
    >
        <div
            *ngIf="items.items.length > 0"
            class="container-slider image_Only"
        >
            <ng-container *ngTemplateOutlet="btnShowAll"></ng-container>
            <div class="container-main-slider track-square">
                <ng-template
                    ngFor
                    [ngForOf]="items.items"
                    let-item
                    let-idx="index"
                    [ngForTrackBy]="trackByFn"
                >
                    <div
                        (click)="[
                                    analyticsEvent(item.identifier, item.title, idx),
                                    navigate(item.identifier, item.title)
                                  ]"
                        class="slider-medium-square-item"
                    >
                        <div class="square-pic">
                            <img
                                src="assets/img/placeholder.png"
                                [lazySrc]="BASE_HREF_IMAGE +'/content/books/' +item.audioBookId +'/pic.jpg?w=250&h=250&mode=stretch&t=' +item.recordVersion"
                                lazySrcVisible="visible"
                                loading="lazy"
                                class="square-image"
                            >
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </ng-template>
    <ng-template
        ngSwitchDefault
        *ngIf="items.items"
    >
        <ng-container *ngTemplateOutlet="Simple_H"></ng-container>
    </ng-template>
</ng-container>
<ng-template #null></ng-template>
<ng-template #Simple_H>
    <div
        *ngIf="items?.items.length > 0"
        class="container-slider Simple_H"
        [class.old-device]="!isNewDevices"
    >
        <ng-container *ngTemplateOutlet="btnShowAll"></ng-container>
        <div class="container-main-slider">
            <div
                class="wrapper-container"
                [ngStyle]="{ direction: isNewDevices ? 'rtl' : 'ltr' }"
            >
                <ng-template
                    ngFor
                    [ngForOf]="items.items"
                    let-item
                    let-i="index"
                    let-first="first"
                    let-last="last"
                    [ngForTrackBy]="trackByFn"
                >
                    <div
                        (click)="[
                                    $event.preventDefault(),
                                    analyticsEvent(item.identifier, item.title, i),
                                    navigate(item.identifier, item.title, item)
                                  ]"
                        class="items"
                    >
                        <ng-container *ngTemplateOutlet="rating; context: item.rating"></ng-container>
                        <div class="container-img">
                          <ng-template [ngIf]="showContextMenuIcon">
                            <ng-container *ngTemplateOutlet="context_menu; context:{ identifier:item.identifier, audiobookId: item.audioBookId, title: item.title, subscriptionStatus: item?.subscriptionStatus, isOwner: item?.isOwner }"></ng-container>
                          </ng-template>
                            <img
                                [lazySrc]="BASE_HREF_IMAGE + '/content/books/' + item.audioBookId + '/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion"
                                lazySrcVisible="visible"
                                src="assets/img/placeholder.png"
                                class="wrapper-img-slider"
                                [alt]="item.title"
                            >
                          <ng-template [ngIf]="item?.subscriptionStatus?.isSubscriptionConsumption">
                            <ng-container *ngTemplateOutlet="navaar_logo_icon_new_subscription;"></ng-container>
                          </ng-template>
                          <ng-container *ngTemplateOutlet="subscription_status; context: { $implicit: item?.subscriptionStatus }"></ng-container>
                          <ng-container *ngTemplateOutlet="discountBadge; context: { $implicit: item }"></ng-container>
                        </div>
                        <div class="container-desc">
                            <h2 class="truncate">
                                <span [textContent]="item.title"></span>
                            </h2>
                            <ng-container *ngTemplateOutlet="authors;context: { $implicit: item.authors }"></ng-container>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-template>
<ng-template
    #rating
    let-rateNumber="average"
>
    <div
        *ngIf="rateNumber"
        [ngStyle]="rateStyle"
        class="rate-number"
        [textContent]="rateNumber"
    ></div>
</ng-template>
<ng-template #shadow>
    <div class="shadow-img-series">
        <div class="shadow-img-series-over-one shadow-img-series-box-over"></div>
        <div class="shadow-img-series-over-two shadow-img-series-box-over"></div>
    </div>
</ng-template>
<ng-template #btnShowAll>
    <ng-container [ngSwitch]="styleShowAll">
        <ng-template [ngSwitchCase]="'grey-icon'">
            <div class="container-title-slider">
                <div class="right-title-slider">
                    <ng-container *ngTemplateOutlet="badgeId"></ng-container>
                    <p [textContent]="title"></p>
                </div>
                <div
                    class="container-btn"
                    *ngIf="typeUrl"
                >
                    <navaar-button
                        (onClick)="goToList()"
                        [type-button]="'button'"
                        [color-name]="'grey-icon'"
                    >
                        <span>همه</span>
                        <navaar-chevron-icon></navaar-chevron-icon>
                    </navaar-button>
                </div>
            </div>
        </ng-template>
        <ng-template [ngSwitchCase]="'yellow'">
            <div class="container-title-slider">
                <div class="right-title-slider">
                    <ng-container *ngTemplateOutlet="badgeId"></ng-container>
                    <p [textContent]="title"></p>
                </div>
                <div
                    class="container-btn"
                    *ngIf="typeUrl"
                >
                    <navaar-button
                        (onClick)="goToList()"
                        [type-button]="'button'"
                        [class-name]="'style-btn-all-yellow'"
                        [color-name]="'no-color'"
                    >
                        <span>همه</span>
                        <navaar-chevron-icon color="#ffb500"></navaar-chevron-icon>
                    </navaar-button>
                </div>
            </div>
        </ng-template>
        <ng-template [ngSwitchCase]="'blue'">
            <div class="container-title-slider">
                <div class="right-title-slider">
                    <ng-container *ngTemplateOutlet="badgeId"></ng-container>
                    <p [textContent]="title"></p>
                </div>
                <div class="container-btn">
                    <navaar-button
                        (onClick)="goToList()"
                        [type-button]="'button'"
                        [color-name]="'blue'"
                    >
                        <span>همه</span>
                        <navaar-chevron-icon></navaar-chevron-icon>
                    </navaar-button>
                </div>
            </div>
        </ng-template>
        <ng-template [ngSwitchCase]="'grey'">
            <div class="container-title-slider">
                <div class="right-title-slider">
                    <ng-container *ngTemplateOutlet="badgeId"></ng-container>
                    <p [textContent]="title"></p>
                </div>
                <div class="container-btn">
                    <navaar-arrow-icon (click)="goToList()"></navaar-arrow-icon>
                </div>
            </div>
        </ng-template>
        <ng-template [ngSwitchCase]="'no-icon'">
            <div class="container-title-slider">
                <div class="right-title-slider">
                    <ng-container *ngTemplateOutlet="badgeId"></ng-container>
                    <p [textContent]="title"></p>
                </div>
            </div>
        </ng-template>
    </ng-container>
</ng-template>
<ng-template #badgeId>
    <ng-container [ngSwitch]="BadgeType">
        <ng-template [ngSwitchCase]="'BestSeller'">
            <span class="icon-title-slider">
                <navaar-best-seller-icon></navaar-best-seller-icon>
            </span>
        </ng-template>
        <ng-template [ngSwitchCase]="'Latest'">
            <span class="icon-title-slider">
                <navaar-latest-icon></navaar-latest-icon>
            </span>
        </ng-template>
        <ng-template [ngSwitchCase]="'Button'"></ng-template>
    </ng-container>
</ng-template>
<ng-template
    #authors
    let-item
>
    <ng-container *ngIf="item">
        <p
            class="truncate"
            *ngIf="item.length > 0"
        >
            <span [textContent]="item[0].firstName + ' ' + item[0].lastName"></span>
        </p>
    </ng-container>
</ng-template>
<ng-template
    #discountBadge
    let-item
>
    <div
        class="discount-badge"
        *ngIf="
      item.products &&
      item.products.length > 0 &&
      item.products[0] &&
      item.products[0].price &&
      item.products[0].price != item.products[0].discountedPrice
    "
    >
        %
        <span [textContent]="
        item.products[0].discount.promotionValue * 100 | number: '1.0-0'
      "></span>
    </div>
</ng-template>
<ng-template #context_menu let-title="title" let-identifier="identifier" let-audiobookId="audiobookId" let-subscriptionStatus="subscriptionStatus" let-isOwner="isOwner">
  <span class="context-menu-icon" (click)="onShowContextMenu($event, identifier, audiobookId, title, subscriptionStatus, isOwner)">
    <navaar-more-vert-icon></navaar-more-vert-icon>
  </span>
</ng-template>
<ng-template #subscription_status let-subscription>
  <ng-template [ngIf]="isCheckStatusSubscription">
    <div class="wrapper-subscription-status" *ngIf="subscription != null ? (subscription?.isSubscriptionConsumption && subscription?.isExpired) : false">
      <navaar-lock-icon [width]="'60px'" [color]="'#ffffff60'"></navaar-lock-icon>
    </div>
  </ng-template>
</ng-template>
<ng-template #navaar_logo_icon_new_subscription>
  <div class="navaar-logo-icon-show-subscription">
    <navaar-logo-simple-icon></navaar-logo-simple-icon>
  </div>
</ng-template>

